import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export default styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  .header-page-left {
    display: flex;
    padding-top: 24px;
    flex-direction: column;
    gap: 10px;
    span {
      font-family: ${Theme.fontFamily.PRIMARY};
      font-size: 16px;
      font-weight: 300;
      letter-spacing: 0.1px;
      font-weight: 700;
      text-align: left;
      color: ${Theme.pallete.PRIMARY};
    }
    div {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  .header-page-right {
    position: absolute;
    right: 24px;
    top: 24px;
  }
`
